import clsx from "clsx";
import React from "react";
import useStyles from "./styles";

export interface Props {
  isToday?: boolean;
  date: Date;
}

const DisabledDate = (props: Props) => {
  const { isToday, date } = props;
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <span
        className={clsx(classes.date, {
          [classes.squared]: isToday
        })}
      >
        {date.getDate()}
      </span>
    </div>
  );
};

export default React.memo(DisabledDate);
